import { PreguntaDTO } from "@DTOS";
import { PreguntasTipoEnum } from "@shared/enums";

declare module "../../DTOS/Pregunta.DTO" {
    interface PreguntaDTO {
        esMatriz(): boolean;
    }
}

PreguntaDTO.prototype.esMatriz = function() {
    return this.tipo === PreguntasTipoEnum.MATRIX_SINGLE ||
    this.tipo === PreguntasTipoEnum.MATRIX_MULTIPLE ||
    this.tipo === PreguntasTipoEnum.MATRIX_RANGE;
};
